var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14269_2680)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 25,
    rx: 25,
    ry: 25,
    fill: "#1C2227",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 27.1293L17.5475 34.5817C17.2687 34.8606 16.9138 35 16.4829 35C16.052 35 15.6971 34.8606 15.4183 34.5817C15.1394 34.3029 15 33.948 15 33.5171C15 33.0862 15.1394 32.7313 15.4183 32.4525L22.8707 25L15.4183 17.5475C15.1394 17.2687 15 16.9138 15 16.4829C15 16.052 15.1394 15.6971 15.4183 15.4183C15.6971 15.1394 16.052 15 16.4829 15C16.9138 15 17.2687 15.1394 17.5475 15.4183L25 22.8707L32.4525 15.4183C32.7313 15.1394 33.0862 15 33.5171 15C33.948 15 34.3029 15.1394 34.5817 15.4183C34.8606 15.6971 35 16.052 35 16.4829C35 16.9138 34.8606 17.2687 34.5817 17.5475L27.1293 25L34.5817 32.4525C34.8606 32.7313 35 33.0862 35 33.5171C35 33.948 34.8606 34.3029 34.5817 34.5817C34.3029 34.8606 33.948 35 33.5171 35C33.0862 35 32.7313 34.8606 32.4525 34.5817L25 27.1293Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14269_2680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close_circle.5c8512ce61afcdbb94a687152c342432.svg";
export { ForwardRef as ReactComponent };